export default __webpack_public_path__ + "static/lower2_2-2612b6e2ab765d4fbd93072168802d27.jpg";